import axios from 'axios';
import { useEffect, useState } from 'react'

const useFetch = (url) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState([]);

  useEffect(()=>{
    setLoading(true);
    axios.get(`https://portfolio-backend-abdul-khaliq.herokuapp.com/api/v1${url}`).then((response)=>{
      const resp_data = response.data;
      setData(resp_data);
    }).catch((error)=>{
      setError(error);
    }).finally(()=>{
      setLoading(false);
    })
  }, [url]);

  return [data, loading, error];
}

export default useFetch